module.exports = __webpack_public_path__ + "img/1300_PAB_2021_Stu.dc06ab30.png";